var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloorArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "floor area",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "24x24"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 40 \\u2013 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29072",
    d: "M4 3.066a.5.5 0 0 1-.382-.177L2.25 1.274.882 2.889a.5.5 0 1 1-.763-.646L1.869.177a.5.5 0 0 1 .763 0l1.75 2.066A.5.5 0 0 1 4 3.066z",
    transform: "rotate(180 2.25 11)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29073",
    d: "M2.25 3.066a.5.5 0 0 1-.382-.177L.119.823A.5.5 0 1 1 .882.177L2.25 1.792 3.619.177a.5.5 0 1 1 .763.646l-1.75 2.066a.5.5 0 0 1-.382.177z",
    transform: "rotate(180 2.25 4.047)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M.5 15.994a.475.475 0 0 1-.5-.444V.444A.475.475 0 0 1 .5 0a.475.475 0 0 1 .5.444V15.55a.475.475 0 0 1-.5.444z",
    transform: "rotate(180 1.374 10.814)",
    style: {
      fill: "gray"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 40 \\u2013 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29072",
    d: "M3.5 2.566a.5.5 0 0 1-.382-.177L1.75.774.382 2.389a.5.5 0 0 1-.7.058.5.5 0 0 1-.058-.7l1.744-2.07A.5.5 0 0 1 1.75-.5a.5.5 0 0 1 .382.177l1.75 2.066a.5.5 0 0 1-.381.823z",
    style: {
      fill: "gray"
    },
    transform: "rotate(-90 4.75 -.75)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29073",
    d: "M1.75 2.566a.5.5 0 0 1-.382-.177L-.382.323a.5.5 0 0 1 .058-.7.5.5 0 0 1 .7.058L1.75 1.292 3.118-.323a.5.5 0 0 1 .7-.058.5.5 0 0 1 .058.7l-1.744 2.07a.5.5 0 0 1-.382.177z",
    transform: "rotate(-90 12.717 -8.717)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M0 17.5a.5.5 0 0 1-.5-.5V0A.5.5 0 0 1 0-.5a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5z",
    transform: "rotate(-90 4.071 -1.823)",
    style: {
      fill: "gray"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8690"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17995",
    transform: "translate(6 6)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 15,
    rx: 1.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29074",
    d: "M-17686.191-22566.584h2.225s.775.178.775 1.318v2.682",
    transform: "translate(17692.691 22580.084)",
    style: {
      strokeLinecap: "round",
      stroke: "gray",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29075",
    d: "M-17681.012-22560.189v-4",
    transform: "translate(17693.512 22581.689)",
    style: {
      strokeLinecap: "round",
      stroke: "gray",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29076",
    d: "M-17681.266-22566h2.5s1 .031 1 .855v4.865",
    transform: "translate(17693.766 22581.5)",
    style: {
      strokeLinecap: "round",
      stroke: "gray",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29093",
    d: "M0 0h3",
    transform: "translate(20.5 13.793)",
    style: {
      strokeLinecap: "round",
      stroke: "gray",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 28",
    transform: "translate(20.5 10.702)",
    style: {
      strokeLinecap: "round",
      stroke: "gray",
      fill: "none"
    },
    d: "M0 0h3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17996",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h7v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V0z",
    style: {
      stroke: "none"
    },
    transform: "translate(10.5 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h6V5A1.5 1.5 0 0 1 5 6.5H2A1.5 1.5 0 0 1 .5 5V.5z",
    style: {
      fill: "none"
    },
    transform: "translate(10.5 6)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29077",
    d: "M-17677.074-22559.689v-3.994a1.139 1.139 0 0 1 1.244-1.006h.635",
    transform: "translate(17695.574 22581.189)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorArea);
export default __webpack_public_path__ + "static/media/floor_area.fce1c81bfc06512312a8d5e1ba5f0dd6.svg";
export { ForwardRef as ReactComponent };